import _ from 'lodash';
import moment from 'moment';

export const tableMixin = {
  methods: {
    _createWorkbook(dataSource, rows) {
      return new kendo.ooxml.Workbook({
        sheets: [
          {
            columns: _.map(_.range(0, dataSource.length + 1), () => ({autoWidth: true})),
            rows
          }
        ]
      });
    },

    exportAsExcel(dataSource, columns) {
      const rows = [{
        cells: _.map(columns, column => ({value: column.label}))
      }];

      _.forEach(dataSource, (val, key) =>
          rows.push({
            cells: _.map(columns, column => ({
              value: val[column.field]
            }))
          })
      );

      const workbook = this._createWorkbook(dataSource, rows);
      // save the file as Excel file with extension xlsx
      try {
        kendo.saveAs({
          dataURI: workbook.toDataURL(),
          fileName: `${moment(new Date()).format('YYYYMMDD-hhmmss')}_gig-chart-table.xlsx`
        });
      } catch (err) {
        return err;
      }
    },

    exportHtmlToExcel(table, filename) {
      // const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel;charset=UTF-8"><head></head><body><table>${table}</table></body></html>`;
      const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel;charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${'worksheet'}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table.replace(/<img[^>]*>/g, '')}</table></body></html>`;
      const blob = new Blob([template], {
        type: 'application/vnd.ms-excel;charset=UTF-8'
      });

      kendo.saveAs({
        dataURI: window.URL.createObjectURL(blob),
        fileName: filename || `${moment(new Date()).format('YYYYMMDD-hhmmss')}_gig-chart-table.xls`
      });
    }
  }
};
